<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right"></div>
                    <h4 class="page-title">Update Trainee Last Followup</h4>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div v-show="show"
                     class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <span v-for="(err, index) in validation_errors" :key="index">
                                      {{ err[0] }} <br/>
                                    </span>
                </div>
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="question_1">Question 1<span class="c-required">*</span></label>
                                <input type="text" id="question_1" v-model="followup.question_1"
                                       v-validate="{ required: true }" class="form-control form-control-sm" name="question_1" />
                                <div class="invalid-feedback">Please enter valid information</div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="question_2">Question 2 <span class="c-required">*</span></label>
                                <input type="text" v-model="followup.question_2" v-validate="{ required: true }"
                                       id="question_2" name="question_2" class="form-control form-control-sm"/>
                                <div class="invalid-feedback">Please enter valid information</div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="question_3">Question 3 <span class="c-required">*</span></label>
                                <input type="text" id="question_3" v-model="followup.question_3"
                                       v-validate="{ required: true }" class="form-control form-control-sm" name="question_3"/>
                                <div class="invalid-feedback">Please enter valid information</div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="question_4">Question 4<span class="c-required">*</span></label>
                                <input type="text" v-model="followup.question_4" v-validate="{ required: true }"
                                       id="question_4" name="question_4" class="form-control form-control-sm"/>
                                <div class="invalid-feedback">Please enter valid information</div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="question_5">Question 5 <span class="c-required">*</span></label>
                                <input type="text" id="question_5" v-model="followup.question_5"
                                       v-validate="{ required: true }" class="form-control form-control-sm"
                                       name="question_5"/>
                                <div class="invalid-feedback">Please enter Remarks</div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="date">Date  <span class="c-required">*</span></label>
                                <datepicker v-model="followup.date" v-validate="'required'"
                                            id="date"  name="date" :format="customEndDate"></datepicker>
                                <div v-if="errors.has('date')" class="text-danger"
                                     style="margin-top: 0.25rem; font-size: 0.75rem;">Date required
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="remarks">Remarks <span class="c-required">*</span></label>
                                <input type="text" id="remarks" v-model="followup.remarks"
                                       v-validate="{ required: true }" class="form-control form-control-sm"
                                       name="remarks"/>
                                <div class="invalid-feedback">Please enter Remarks</div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-lg-4">
                                <label for="step">Training Step  <span class="c-required">*</span></label>
                                <select v-model="followup.step"
                                        v-validate="'required'" id="step" name="step" class="form-control form-control-sm">
                                    <option value="999">Training Last</option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select valid information.
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <button class="btn btn-success waves-effect waves-light mr-2"
                                        @click.prevent="update">Update
                                </button>
                                <router-link
                                        :to="{name: 'mansionWorkFollowupList',params: { trainee_id: followup.trainee_id }}"
                                        tag="a"
                                        class="btn btn-warning waves-effect waves-light mr-2" title="Trainee Followup List">Back
                                </router-link>
                            </div>
                        </div>
                    </form>
                </b-card>
            </div>
        </div>

    </Layout>
</template>

<script>
    import Datepicker from "vuejs-datepicker";
    import Multiselect from "vue-multiselect";

    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import moment from "moment";

    export default {
        page: {
            title: "Update Trainee Last Followup",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, Datepicker, Multiselect},
        data() {
            return {
                title: "Update Trainee Last Followup",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trainee Followup",
                        active: true
                    }
                ],
                followup: {
                    question_1: '',
                    question_2: '',
                    question_3: '',
                    question_4: '',
                    question_5: '',
                    date: '',
                    remarks: '',
                    step: '',
                },
                trainee_id: '',
                validation_errors: {},
                show: false,
            };
        },

        mounted() {
            this.getFollowup();
        },
        methods: {
            customEndDate(date) {
                this.followup.date = moment(date).format("YYYY-MM-DD");
                return moment(date).format("YYYY-MM-DD");
            },
            async update() {
                await this.$validator.validate().then(valid => {
                    if (valid) {
                        http.post("api/trainee/mansion-work/followup_last/update/" + this.followup.id, this.followup)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });

                                    this.$router.push("/trainee/mansion-work/followup/list/" + this.followup.trainee_id);

                                } else {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                }
                            })
                            .catch()
                    }
                });
            },
            getFollowup(){
                let followup_id = this.$route.params.followup_id;

                http.get("api/trainee/mansion-work/followup_last/edit/" + followup_id ).then(response => {
                    if (!response.data.error) {
                        this.followup = response.data.trainee_followup;
                    }
                });
            }
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    @import "vue-select/src/scss/vue-select.scss";

    .c-required {
        color: red;
    }

    .vdp-datepicker input {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #ced4da;
        height: 30px;
        padding-left: 15px;
        color: #6b757d;
    }
</style>
